// Lectura del reporte crudo de ventas de Mercado Libre (hoja "Ventas MX", encabezado en la fila 6).
// Regresa un renglon por articulo vendido con su precio neto, sin tocar el catalogo (eso lo hace la pantalla).
//
//  - Solo cuenta lo que ML SI pago ("Total (MXN)" > 0), sin importar el estado: canceladas, devoluciones
//    reembolsadas y paquetes no entregados vienen en 0. Las que estan en devolucion/reclamo pero ML ya
//    pago si cuentan (si el producto regresa se registra la devolucion).
//  - Paquetes: el renglon "Paquete de N productos" trae los montos, la forma de entrega y el modelo de venta;
//    sus N renglones siguientes (los articulos) vienen sin montos y con la forma de entrega en blanco. Cada
//    articulo hereda los datos del paquete y le toca su parte del monto por precio unitario x unidades.
//    (La columna "Paquete de varios productos" dice "Si" en casi todo: no sirve para reconocerlos.)
//  - Precio neto = ingresos - comision - envio - retenciones (ISR 2.5% + IVA 8% sobre el precio sin IVA,
//    que ya vienen dentro de "Cargo por venta e impuestos"). Reventa: lo que paga ML, sin descuentos.

const r2 = (n) => Number(Number(n).toFixed(2));
const num = (v) => Number(v) || 0;

export function renglonesReporteMeli(rows) {
  // ML renombra la columna del precio: se busca por prefijo
  const colPrecio = rows.length ? Object.keys(rows[0]).find((k) => k.startsWith("Precio unitario")) : null;
  const precioUnitario = (r) => num(colPrecio ? r[colPrecio] : 0);

  const padreDe = new Map(); // indice del articulo -> indice de su renglon "Paquete de N productos"
  rows.forEach((r, i) => {
    const m = String(r["Estado"] || "").match(/^Paquete de (\d+) productos/);
    if (m) for (let k = 1; k <= Number(m[1]); k++) padreDe.set(i + k, i);
  });
  const pesoPaquete = new Map();
  padreDe.forEach((p, h) => {
    pesoPaquete.set(p, (pesoPaquete.get(p) || 0) + precioUnitario(rows[h]) * num(rows[h]["Unidades"]));
  });

  const renglones = [];
  const noPagadas = [];
  let enPaquete = 0;
  rows.forEach((r, i) => {
    const sku = String(r["SKU"] || "").trim();
    if (!sku) return; // renglon del paquete (sus articulos vienen abajo)
    const unidades = num(r["Unidades"]);
    if (unidades <= 0) return;

    const iPadre = padreDe.get(i);
    const fuente = iPadre !== undefined ? rows[iPadre] : r; // de donde salen montos, entrega y modelo
    const parte = iPadre === undefined
      ? 1
      : pesoPaquete.get(iPadre) ? (precioUnitario(r) * unidades) / pesoPaquete.get(iPadre) : 0;
    const totalML = r2(num(fuente["Total (MXN)"]) * parte);
    if (totalML <= 0) {
      noPagadas.push(sku);
      return;
    }

    const formaEntrega = String(fuente["Forma de entrega"] || "").trim();
    const esReventa = String(fuente["Modelo de venta"] || "").toLowerCase().includes("reventa");
    const ingresos = num(fuente["Ingresos por productos (MXN)"]) * parte || precioUnitario(r) * unidades;
    const precioBruto = r2(ingresos / unidades);
    let comision = 0;
    let envio = 0;
    let retencionISR = 0;
    let retencionIVA = 0;
    if (!esReventa) {
      // envio neto que absorbe el vendedor por unidad
      envio = r2(((Math.abs(num(fuente["Costos de envío (MXN)"])) - num(fuente["Ingresos por envío (MXN)"])) * parte) / unidades);
      const cargoPorUnidad = (Math.abs(num(fuente["Cargo por venta e impuestos (MXN)"])) * parte) / unidades;
      retencionISR = r2((precioBruto / 1.16) * 0.025);
      retencionIVA = r2((precioBruto / 1.16) * 0.08);
      if (retencionISR + retencionIVA > cargoPorUnidad) {
        retencionISR = 0;
        retencionIVA = 0;
      }
      comision = r2(cargoPorUnidad - retencionISR - retencionIVA);
    }
    const precio = r2(precioBruto - comision - envio - retencionISR - retencionIVA);
    if (iPadre !== undefined) enPaquete++;

    renglones.push({
      sku,
      unidades,
      venta: String(r["# de venta"] || "").trim(),
      comprador: r["Comprador"] || fuente["Comprador"] || "",
      formaEntrega,
      esFull: formaEntrega.toLowerCase().includes("full"),
      esReventa,
      enPaquete: iPadre !== undefined,
      precioBruto,
      precioSinIVA: r2(precioBruto / 1.16),
      porcentajeComision: precioBruto > 0 ? r2((comision / precioBruto) * 100) : 0,
      comision,
      envio,
      retencionISR,
      retencionIVA,
      precio,
      total: r2(precio * unidades),
      totalML,
    });
  });
  return { renglones, noPagadas, enPaquete, colPrecio };
}
